import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclMapRulesInterfaceService {

  intervalDelay = 2000;
  formbirdInjectorService: any;
  changedDocumentService: any;
  subs: any;
  constructor() { }
  init(formbirdInjectorService , changedDocumentService , subs) {
    this.formbirdInjectorService = formbirdInjectorService;
    this.changedDocumentService = changedDocumentService;
    this.subs = subs;
  }

  initWatchInterval(ClientRuleService: any, $interval, cb) {
    ClientRuleService.$interval = $interval;
    ClientRuleService.intervalDelay = this.intervalDelay;
    $interval(function() {
        cb();
    }, this.intervalDelay);
  }
  // Generic global variable functions
  // These should be moved to a seperate library at some stage when I can work out how to call it from
  //   both the components load function and then the rules script
  setRCGlobal(component, componentName, variable, value) {
    const ClientRulesService = this.formbirdInjectorService.get('ClientRulesService');
    const varName = component + '_' + componentName + '_' + variable;
    ClientRulesService.setSharedValue(varName, {value: value, time: new Date().getTime()});
    // logger.info("setRCGlobal: setSharedValue["+varName+"].value = "+JSON.stringify(ClientRulesService.getSharedValue(varName).value));
  }
  getRCGlobal(component, componentName, variable) {
    const ClientRulesService = this.formbirdInjectorService.get('ClientRulesService');
    const varName1 = component + '_' + componentName + '_' + variable;
    // logger.info("getRCGlobal: getSharedValue["+varName+"].value == "+JSON.stringify(ClientRulesService.getSharedValue(varName).value));
    return ClientRulesService.getSharedValue(varName1).value;
  }
  watchRCGlobal(component, componentName, variable, callback) {
    const varName2 = component + '_' + componentName + '_' + variable;
    // logger.info("watchRCGlobal : Not yet implemented. No callback for " + varName);
  }
  // Map "layers" functions
  getMapLayers(component, componentName) {
    return this.getRCGlobal(component, componentName, 'layers-field');
  }
  setMapLayers(component, componentName, layers, isFirstSet, componentDefinition, documentId) {
    this.setRCGlobal(component, componentName, 'layers-field', layers);
    if (isFirstSet) {
      this.createWatchLayers(componentDefinition, documentId);
    }
  }
  createWatchLayers(componentDefinition, documentId) {
    const field = componentDefinition;
    const ClientRulesService = this.formbirdInjectorService.get('ClientRulesService');
    // const observeOnScope =  this.formbirdInjectorService.get('observeOnScope');
    // const varName = field.componentName + '_' + field.name + '_' + 'layers-field';
    // observeOnScope(scope, function() {
    //   return ClientRulesService.getSharedValue(varName);
    // }, true).subscribe(function(change) {
    //   // logger.info("Observable Watch Function for field.layers",change,change.newValue);
    //   const objValue = change.newValue.value;
    //   componentDefinition.layers = objValue;
    // });
    const scopeSub = this.changedDocumentService.watchDocument(documentId).subscribe(newValue => {
      componentDefinition.layers = newValue;
    });
    this.subs.add(scopeSub);
  }
  watchLayers(component, componentName, callback) {
    this.watchRCGlobal(component, componentName, 'layers-field', callback);
  }
  // Map view bounding box coordinates
  setCurrentMapviewCoords(component, componentName, value, isFirstSet, isSetOnMoveEnd
                        , componentDefinition, documentId, MapFunc) {
    this.setRCGlobal(component, componentName, 'MapBoundingBox', value);
    if (isFirstSet) {
      this.createWatchMapviewCoords(componentDefinition, documentId, MapFunc);
    }
    this.setRCGlobal(component, componentName, 'isSetOnMoveEnd', isSetOnMoveEnd ? true : false);
  }
  getCurrentMapViewCoordsIsSetOnMoveEnd(component, componentName) {
      return this.getRCGlobal(component, componentName, 'isSetOnMoveEnd');
  }
  getCurrentMapviewCoords(component, componentName) {
    return this.getRCGlobal(component, componentName, 'MapBoundingBox');
  }
  createWatchMapviewCoords(componentDefinition, documentId, MapFunc) {
    const field = componentDefinition;
    const ClientRulesService = this.formbirdInjectorService.get('ClientRulesService');
    // var observeOnScope = $injector.get('observeOnScope');
    const varName = field.componentName + '_' + field.name + '_' + 'MapBoundingBox';
    const scopeSub = this.changedDocumentService.watchDocument(documentId).subscribe(objValue => {
      if (objValue) {
        const latlng = objValue[1];
        // logger.info("sclMapRulesInterface=>Observable Watch Function for MapviewCoords, latlng= " + latlng,scope.MapFunc);
        // logger.info("sclMapRulesInterface, ol = " + ol);
        if (MapFunc && (objValue != null && objValue.length === 2)) {
            if (!ClientRulesService.getSharedValue(field.componentName + '_' + field.name + '_' + 'isSetOnMoveEnd').value) {
              // logger.info("setCentermapViewByCoordinates is triggered");
              MapFunc.mapObj.setCenterMapViewByCoordinates(objValue);
            }

        }
      }
    });
    this.subs.add(scopeSub);
  }
}
